import React from 'react';
import ReactHtmlParser from '@orrisroot/react-html-parser';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { Store } from 'types/store';
import useReferrerParam from 'hooks/useReferrerParam';
import errorTriangle from 'images/icons/error-triangle.svg';
import journeyClosed from 'images/icons/journey-closed.svg';
import styles from './ErrorMessage.module.scss';

export const ErrorMessageEnum = {
  ERROR: 'ERROR',
  CLOSED: 'CLOSED',
} as const;

export type ErrorMessageEnumType = keyof typeof ErrorMessageEnum;

const ErrorMessage: React.FC = () => {
  const { journeyError } = useSelector((state: Store) => state.journeys.loyaltyRewards);
  const isAppView = useReferrerParam();

  if (!journeyError) {
    return null;
  }

  const icon = journeyError.messageType === ErrorMessageEnum.CLOSED ? journeyClosed : errorTriangle;
  const altText = journeyError.messageType === ErrorMessageEnum.CLOSED ? 'Closed icon' : 'Error icon';

  return (
    <div className={clsx(styles.errorScreen, {
        [styles.closed]: journeyError.messageType === ErrorMessageEnum.CLOSED,
        [styles.isAppViewError]: isAppView,
      })}
    >
      <img src={icon} alt={altText} />
      <h2>{journeyError.title}</h2>
      <p>{ReactHtmlParser(journeyError.description)}</p>
    </div>
  );
};

export default ErrorMessage;
